import { render, staticRenderFns } from "./smarthPhone.vue?vue&type=template&id=77253c43&"
import script from "./smarthPhone.vue?vue&type=script&lang=js&"
export * from "./smarthPhone.vue?vue&type=script&lang=js&"
import style0 from "./smarthPhone.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports